<template>
    <div :id="this.$route.name">
        <card back >
            <template v-slot:header>
            <h4 class="d-inline">{{title}} شماره : {{TaskStatus.id}}</h4>
            <hr>    
            </template>
            <template v-slot:content>
                <form @submit.prevent="$ValidForm(this)" autocomplete="off">
                <div class="row">
                    <div class="col-md-9 col-12">
                        <small id="LblTaskSubject">عنوان فعالیت</small>
                        <input  type="text" class="form-control InputText required" v-model="DataAxios.TaskSubject" :disabled="Isdisabled" />
                    </div>
                    <div class="col-md-3 col-12">
                        <small id="LblGrp14">اولویت</small>
                        <SearchableCombo
                            :edit="false"
                            :grp="14"
                            :code="null"
                            @ResultCombo="GetResulGrp14"
                            :rownumintable="3"
                            :defaultvalue="DataAxios.TblComboIdGrp14"
                            :action="'TblCrmCombo/GetComboById'"
                            :method="'POST'"
                            :idinput="'Grp14'"
                            :keyItem="'Grp14'"
                            :disabled="Isdisabled"
                            :ClassProps="'required'">
                        </SearchableCombo>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-2 col-12">
                        <small id="LblTaskDate"> تاریخ فعالیت</small>
                        <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.TaskDate" clearable :editable="true" placeholder="تاریخ فعالیت" :disabled="Isdisabled"></date-picker>
                    </div>
                     <div class="col-md-2 col-12">
                        <small id="LblTaskTime"> زمان فعالیت</small>
                        <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.TaskTime" clearable :editable="true" placeholder="زمان فعالیت" type="time" :disabled="Isdisabled"></date-picker>
                    </div>
                    <div class="col-md-2 col-12">
                        <small id="LblDoneDeadline">مهلت انجام</small>
                        <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.DoneDeadline" clearable :editable="true" placeholder="مهلت انجام" :disabled="Isdisabled"></date-picker>
                    </div>
                    <div class="col-md-3 col-12">
                        <small id="LblUserId">ارجاع به </small>
                        <SearchableCombo
                            :edit="false"
                            :grp="0"
                            :code="null"
                            @ResultCombo="GetResulUserId"
                            :rownumintable="3"
                            :defaultvalue="DataAxios.TblUserIdTask"
                            :action="'TblCrmCombo/GetUserDatails'"
                            :method="'POST'"
                            :idinput="'UserId'"
                            :keyItem="'UserId'"
                            :disabled="Isdisabled"
                            :ClassProps="'required'">
                        </SearchableCombo>
                    </div>
                    <div class="col-md-3 col-12">
                        <small id="LblTblCostomer">مربوط به مشتری</small>
                        <SearchableCombo
                            :edit="false"
                            :grp="0"
                            :code="null"
                            @ResultCombo="GetResulTblCostomer"
                            :rownumintable="3"
                            :defaultvalue="DataAxios.TblCustomerId"
                            :action="'TblCrmCombo/GetCostomer'"
                            :method="'POST'"
                            :idinput="'TblCostomer'"
                            :keyItem="'TblCostomer'"
                            :disabled="true"
                            >
                        </SearchableCombo>
                    </div>
                </div>
                <div class="row mt-3">
                    
                    <div class="col-md-3 col-12">
                        <small id="LblIsView">نیاز به پاسخ</small>
                        <div class="form-control custom-switch">
                        <input type="checkbox" class="form-control-input InputText m-1" id="IsReply"  v-model="DataAxios.IsReply" :disabled="$route.params.Status=='Add' ? false : true " />
					        <label  class="label txt-bnp  mr-2" for="IsReply">
					           نیاز به پاسخ دارد
					        </label>
					    </div>
                    </div>
                    <div  v-if="$route.params.Status=='Edit' " class="col-md-3 col-12">
                        <small id="LblDone"> وضعیت انجام</small>
                        <div class="form-control custom-switch">
					        <input type="checkbox" class="form-control-input InputText m-1" id="Done" :disabled="DataAxios.Done" v-model="DataAxios.Done" />
					        <label class="form-control-label mr-2" for="Done">
					           {{txtDone}}
					        </label>
					    </div>
                    </div>
                    <div  v-if="$route.params.Status=='Edit' && DataAxios.TblUserIdTask==$session.get('UserInfo').tblUserId " class="col-md-3 col-12">
                        <small id="LblIsView">وضعیت مشاهده</small>
                        <div class="form-control custom-switch">
					        <input type="checkbox" class="form-control-input InputText m-1" id="IsView"  v-model="DataAxios.IsView" :disabled=" DataAxios.Done==true" />
					        <label  class="label txt-bnp  mr-2" for="IsView">
					           {{txtIsView}} ({{DataAxios.DateView}})
					        </label>
					    </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-md-6 col-12">
                        <small id="LblTaskDes">توضیحات</small>
                        <textarea @keypress="$ValidPersian($event, 250)" rows="3" type="text" id="TaskDes" class="form-control InputText" v-model="DataAxios.TaskDes" :disabled="Isdisabled"></textarea>     
                    </div>
                </div>
                </form>
                <hr>
                <button v-if="$route.params.Status=='Add'" class="btn btn-success mr-5" @click.prevent="SaveDeta()">ثبت اطلاعات</button>
                <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel()">انصراف</button>
            </template>
            
        </card>
    </div>
</template>
<script>
import Card from "@/components/Card/Card.vue"
import BtnEditData from '@/components/BnpButtons/BtnEditData.vue';
import BtnSaveData from '@/components/BnpButtons/BtnSaveData.vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
export default {
  components: { Card,datePicker: VuePersianDatetimePicker,BtnEditData ,BtnSaveData,SearchableCombo},
    data(){
        return{
            Okreply:false,
            DataAxiosPost: {
                ArryfildValue: {},
                Method: 'post',
                Action: '',
                Token: this.$session.get('Token'),
                From: 'Body',
            },
            DataAxiosUpdate: {
                ArryfildValue: {},
                Method: "put",
                Action: "",
                Token: this.$session.get("Token"),
                From: "Body",
            },
            title:'',
            list:{'Id':1,'name':'ali'},
            DataAxios:{
            },
            txtDone: 'این کـار انجام شده',
            Isdisabled:false,
            txtIsView: 'این کـار مشاهده شده'
        }
    },
    created(){
        if (this.$route.params.Status) {
            if (this.$route.params.Status == "Add") {
                 this.title='پاسخ به کـار '
                 this.DataAxios.TaskDate=this.$store.state.JalaliDate;
                 this.DataAxios.TaskTime=this.$store.state.JalaliTime;
                 this.DataAxios.DoneDeadline=this.$store.state.JalaliDate;
                 this.DataAxios.TblUserGrpIdInsert=this.$session.get("UserInfo").tblUserGrpId
                this.DataAxios.ParentId=this.TaskStatus.id
                this.DataAxios.TblCustomerId=this.TaskStatus.tblCustomerId
            }else{
                this.title='ویـرایـش کـار'
            }
        }else{
            this.$router.push({ name: this.$route.name.substring(6)});
        }
    },
    methods:{
        SaveEditDeta(){
            this.$SetLog(this.DataAxios, 0);
            this.DataAxiosUpdate.Action = 'Task'
            this.DataAxiosUpdate.ArryfildValue = this.DataAxios;
                this.$PutData_Body(this.DataAxiosUpdate)
                .then((data) => {
                    if (data.status == "Ok") {
                        this.$toasted.warning('پاسخ به کـار انجام نشد ', {
                        action: {
                            text: 'بستن',
                            onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                            },
                        },
                        })
                } else {
                  if (data.eNum == "2601") {
                    this.$mySweetDefaultTost(
                      false,
                      "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
                      "error",
                      3000
                    );
                  }
                }
                }).finally(() => {
                this.$store.state.renderComponentGrid = false;
                this.$store.state.renderComponent = false;
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true;
                  this.$store.state.renderComponent = true;
                });
              })
            
        },
        SaveDeta(){
            if (this.$ValidForm(this.$route.name)) {
            this.DataAxiosPost.Action = 'Task'
            this.DataAxiosPost.ArryfildValue=this.DataAxios
            this.$PostData(this.DataAxiosPost).then((data) => {
                if (data.status == 'Ok') {
                    this.Okreply=true;
                    this.Cancel()
                    this.$toasted.success('فعالیت با موفقیت ایجاد شد', {
                        action: {
                            text: 'بستن',
                            onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                            },
                        },
                        })
                }
                else {
                        this.Okreply=false;
                        if (data.eNum == '2601') {
                        this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                        }
                        if(data.status=="Not Ok"){
                            if(data.mes != undefined){
                               this.$mySweetDefaultTost('خطایی رخ داده!', data.mes, 'error', 3000)
                            }else{
                               this.$mySweetDefaultTost('خطایی رخ داده!', 'امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ', 'error', 3000)
                            }
                        }
                    }
                }).catch((err)=>{
                    this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد فیلدهای ورودی را کنترل نمایید", "error", 2000);
                    console.error("CATCH", err);
                })
            }
           
        },
        Cancel() {
        this.$router.go(-1)
        },
        GetResulUserId(data){
            this.DataAxios.TblUserIdTask=data.id
            
        },
        GetResulTblCostomer(data){
            this.DataAxios.TblCustomerId=data.id
        },
        GetResulGrp14(data){
            this.DataAxios.TblComboIdGrp14=data.id
        }
    },
    props:['TaskStatus'],
   
    beforeDestroy(){

        if(this.Okreply==false){
            this.DataAxios=this.TaskStatus
            this.DataAxios.Done=false;         
            this.DataAxiosUpdate.Action = 'Task'
            this.DataAxiosUpdate.ArryfildValue = this.DataAxios;
                this.$PutData_Body(this.DataAxiosUpdate)
                .then((data) => {
                    if (data.status == "Ok") {
                        this.$toasted.error('پاسخ به کـار انجام نشد ', {
                        action: {
                            text: 'بستن',
                            onClick: (e, toastObject) => {
                            toastObject.goAway(0)
                            this.$store.state.renderComponentGrid = false;
                            this.$store.state.renderComponent = false;
                            this.$nextTick(() => {
                            this.$store.state.renderComponentGrid = true;
                            this.$store.state.renderComponent = true;
                            });
                            },
                        },
                        })
                } else {
                  if (data.eNum == "2601") {
                    this.$mySweetDefaultTost(
                      false,
                      "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
                      "error",
                      3000
                    );
                  }
                }
                }).catch((err) => {
                    this.$mySweetDefaultTost("عملیات ناموفق", "خطایی رخ داد", "error", 2000);
                    console.error("CATCH", err);
                }).finally(() => {
                this.$store.state.renderComponentGrid = false;
                this.$store.state.renderComponent = false;
                this.$nextTick(() => {
                  this.$store.state.renderComponentGrid = true;
                  this.$store.state.renderComponent = true;
                });
                this.$SetLog(this.DataAxios, 0);
              })
        }
    }

}
</script>
<style scoped>
.txt-bnp{
    font-size: 11px;
}
</style>